<!-- Product Card for Mobile View -->
<div
  class="product-card"
  [ngClass]="[getStatusClass(), expanded ? 'expanded' : '']"
>
  <!-- Card Header: Checkbox, Name & SKU, Ellipsis Menu -->
  <div class="card-header">
    <!-- Checkbox -->
    @if (showCheckbox) {
      <div class="card-checkbox" (click)="$event.stopPropagation()">
        <p-checkbox
          [binary]="true"
          [(ngModel)]="selected"
          (ngModelChange)="onCheckboxChange()"
          [disabled]="loading"
        />
      </div>
    }

    <!-- Product Info -->
    <div class="card-info" (click)="onCardClick()">
      <span class="product-name" [title]="product.ProductName">{{
        product.ProductName
      }}</span>
      <div class="product-meta">
        <span class="product-sku">{{ product.Sku || "No SKU" }}</span>
        <span class="meta-separator">|</span>
        <span class="product-type">{{ product.ProductType || "Simple" }}</span>
      </div>
    </div>

    <!-- Status Badge -->
    <div class="card-status">
      <p-tag
        [value]="getStatusText()"
        [severity]="getStatusSeverity()"
        styleClass="status-tag"
      />
    </div>

    <!-- Ellipsis Menu (top right) -->
    <div class="card-actions" (click)="$event.stopPropagation()">
      <p-button
        icon="pi pi-ellipsis-v"
        [text]="true"
        [rounded]="true"
        size="small"
        (onClick)="onMoreActions($event, contextMenu)"
        [disabled]="loading"
        styleClass="mobile-menu-btn"
      />
    </div>
  </div>

  <!-- Card Body: Price and Stock Info -->
  <div class="card-body" (click)="onCardClick()">
    <div class="info-row">
      <!-- Price -->
      <div class="info-item">
        <span class="info-label">PRICE</span>
        <span class="info-value price">{{ formatPrice(product.Price) }}</span>
      </div>

      <!-- Separator -->
      <span class="info-separator"></span>

      <!-- Sale Price (if available) -->
      @if (product.SalePrice) {
        <div class="info-item">
          <span class="info-label">SALE</span>
          <span class="info-value sale-price">{{
            formatPrice(product.SalePrice)
          }}</span>
        </div>
        <span class="info-separator"></span>
      }

      <!-- Stock Level -->
      <div class="info-item">
        <span class="info-label">STOCK</span>
        <span class="info-value stock-badge" [ngClass]="getStockClass()">
          {{ getStockText() }}
        </span>
      </div>

      <!-- Separator -->
      <span class="info-separator"></span>

      <!-- Scheduled Quantity -->
      <div class="info-item">
        <span class="info-label">SCHEDULED</span>
        <span class="info-value">{{ product.QuantityScheduled || 0 }}</span>
      </div>
    </div>
  </div>

  <!-- Card Footer: Scheduled Order Stats only -->
  @if (
    product.TotalQuantityScheduledActive || product.TotalQuantityScheduledPaused
  ) {
    <div class="card-footer">
      <div class="scheduled-stats">
        @if (product.TotalQuantityScheduledActive) {
          <span class="stat active" pTooltip="Active scheduled orders">
            <i class="pi pi-play"></i>
            {{ product.TotalQuantityScheduledActive }}
          </span>
        }
        @if (product.TotalQuantityScheduledPaused) {
          <span class="stat paused" pTooltip="Paused scheduled orders">
            <i class="pi pi-pause"></i>
            {{ product.TotalQuantityScheduledPaused }}
          </span>
        }
      </div>
    </div>
  }
</div>

<!-- Context Menu -->
<p-menu
  #contextMenu
  [model]="contextMenuItems"
  [popup]="true"
  appendTo="body"
/>
